var map = {
	"./01_create_api.json": "uqo+",
	"./02_permission_set.json": "U3vK",
	"./03_request_content.json": "HVe5",
	"./04_sign_discription.json": "huDF",
	"./05_request.json": "2oJ6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nhvi";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/authentication \.json$
// module id = nhvi
// module chunks = 3